import React, { FC, useEffect, useState } from 'react';
import _ from 'lodash';
import { useQueryClient } from '@tanstack/react-query';
import DescLabel from 'src/components/atoms/label/DescLabel';
import { settlementDataStore, settlementNtsDataStore } from 'src/store/settlementInfo';
import 'src/components/atoms/grid/TableGrid/style.scss';
import { setDeDataStore } from 'src/fetch/data/store';
import { addComma, getMemberInfo } from 'src/utils/common';
import {
  contentModalViewStore,
  contentModalDep2ViewStore,
  errorModalViewStore,
} from 'src/store/modal';
import { familyDataStore } from 'src/store/familyInfo';
import SurveyButton from 'src/components/atoms/buttons/SurveyButton';
import { useCountNum } from 'src/utils/AddCount';
import { loanDataStore } from 'src/store/housingfunds/loan';
import { rentFDataStore } from 'src/store/housingfunds/rentf';
import { rentMDataStore } from 'src/store/housingfunds/rentm';
import { rentPDataStore } from 'src/store/housingfunds/rentp';
import { savingsDataStore } from 'src/store/housingfunds/savings';
import { houseLoanInfoDataFn } from 'src/fetch/stepC/houseLoan';
import { houseRentFInfoDataFn } from 'src/fetch/stepC/houseRentF';
import { houseRentMInfoDataFn } from 'src/fetch/stepC/houseRentM';
import { houseRentPInfoDataFn } from 'src/fetch/stepC/houseRentP';
import { houseSaveInfoDataFn } from 'src/fetch/stepC/houseSaving';
import HousingSaveQuestion from 'src/components/organisms/template/StepA/Question/HousingSave';
import HousingLoanQuestion from 'src/components/organisms/template/StepA/Question/HousingLoan';
import HousingRentFQuestion from 'src/components/organisms/template/StepA/Question/HousingRentF';
import HousingRentMQuestion from 'src/components/organisms/template/StepA/Question/HousingRentM';
import { gridOptionSet, gridFnc } from './gridOption';
import './style.scss';

interface Props {}

const HomeTaxData: FC<Props> = () => {
  // const settlementDataInitState = settlementDataStore((state: any) => state.bind);
  const settlementData = settlementDataStore((state: any) => state.result).data || {};

  // const settlementNtsDataInitState = settlementNtsDataStore((state: any) => state.bind);
  const settlementNtsData = settlementNtsDataStore((state: any) => state.result).data || {};
  const ntsInfoParam = settlementNtsDataStore((state: any) => state.param);
  const taxList = settlementNtsData?.list || [];

  // const taxTotal: any = settlementData?.total || {};
  // const totDeterminedPaid = taxTotal.totDeterminedPaid || 0;
  // const totPrePaid = taxTotal.totPrePaid || 0;
  // const totPayablePaid = taxTotal.totPayablePaid || 0;
  // const totRefundPaid = taxTotal.totRefundPaid || 0;
  //

  let refundStatus = 0;
  let refundStatusText = '환급';
  refundStatus = settlementData.total?.totRefundPaid || 0; // 환급/납부
  const determinedPaid = settlementData.total?.totDeterminedPaid || 0; // 결정세액
  const prePaid = settlementData.total?.totPrePaid || 0; // 기납세액
  if (determinedPaid > prePaid) {
    refundStatus = refundStatus * -1;
    refundStatusText = '추가납부';
  }

  const setContentModalState = contentModalViewStore((state: any) => state.set);

  const totalCount = 1;
  let taxType = { text: '환급', status: 'add', seper: '+' };
  if (refundStatus < 0) {
    taxType = { text: '추가납부', status: 'minus', seper: '-' };
  }

  const bindStateData = setDeDataStore(state => state.bindData);

  const [housingOpenOverride, setHousingOpenOverride] = useState<boolean | null>(null);

  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const familyInfoDataState = familyDataStore((state: any) => state.bind);
  const param = userInfoData;

  // 주택자금저축
  const savingList = savingsDataStore((state: any) => state.result).data || [];
  const savingDataState = savingsDataStore((state: any) => state.bind);
  const savingParam = savingsDataStore((state: any) => state.param);

  // 장기주택저당차입금
  const loanList = loanDataStore((state: any) => state.result).data || [];
  const loanDataState = loanDataStore((state: any) => state.bind);
  const loanParam = loanDataStore((state: any) => state.param);

  // 전세
  const rentFList = rentFDataStore((state: any) => state.result).data || [];
  const rentFDataState = rentFDataStore((state: any) => state.bind);
  const rentFParam = rentFDataStore((state: any) => state.param);

  // 월세
  const rentMList = rentMDataStore((state: any) => state.result).data || [];
  const rentMDataState = rentMDataStore((state: any) => state.bind);
  const rentMParam = rentMDataStore((state: any) => state.param);

  // 임대차
  const rentPList = rentPDataStore((state: any) => state.result).data || [];
  const rentPDataState = rentPDataStore((state: any) => state.bind);
  const rentPParam = rentPDataStore((state: any) => state.param);

  // 주택자금저축
  useEffect(() => {
    houseSaveInfoDataFn(errorModalState, param, savingDataState, queryClient, familyInfoDataState);
  }, [savingParam, ntsInfoParam]);
  // 장기주택저당차입금
  useEffect(() => {
    houseLoanInfoDataFn(errorModalState, param, loanDataState, queryClient, familyInfoDataState);
  }, [loanParam, ntsInfoParam]);
  // 전세
  useEffect(() => {
    houseRentFInfoDataFn(errorModalState, param, rentFDataState, queryClient, familyInfoDataState);
  }, [rentFParam, ntsInfoParam]);
  // 월세
  useEffect(() => {
    houseRentMInfoDataFn(errorModalState, param, rentMDataState, queryClient, familyInfoDataState);
  }, [rentMParam, ntsInfoParam]);
  // 임대차
  useEffect(() => {
    houseRentPInfoDataFn(errorModalState, param, rentPDataState, queryClient, familyInfoDataState);
  }, [rentPParam, ntsInfoParam]);

  const sumAmt = (list: any[], col: string) =>
    (list || []).reduce((acc: number, item: any) => acc + (Number(item?.[col]) || 0), 0);

  // const isQuestionDone = (list: any[]) =>
  //   (list || []).length > 0 && (list || []).every((item: any) => item.question_status === 'Y');
  const isQuestionDone = (list: any[]) => {
    const item: any = list[0] || {};
    const resObj = { value: item.question_status || 'N', status: '_wait', label: '설문 미진행' };
    if (item.question_status === 'Y') {
      resObj.status = '_able';
      resObj.label = '공제대상';
    }
    if (item.question_status === 'X') {
      resObj.status = '_unable';
      resObj.label = '공제불가';
    }
    return resObj;
  };

  const setContentModalDep2State = contentModalDep2ViewStore((state: any) => state.set);
  const questionClickEvent = (title: string, content: React.ReactNode) => {
    setContentModalDep2State({
      active: '_active',
      title,
      content,
      styleDef: { width: '750px', height: '900px' },
    });
  };

  const housingSummaryList = [
    {
      title: '주택자금저축',
      amt: sumAmt(savingList, 'amt'),
      htxAmt: sumAmt(savingList, 'htx_amt'),
      done: isQuestionDone(savingList),
      question: {
        title: '주택관련 소득공제(장기주택저당차입금 이자상환액)',
        content: <HousingSaveQuestion />,
      },
    },
    {
      title: '장기주택저당차입금',
      amt: sumAmt(loanList, 'amt'),
      htxAmt: sumAmt(loanList, 'htx_amt'),
      done: isQuestionDone(loanList),
      question: {
        title: '주택관련 소득공제(주택임차차입금 원리금상환액)',
        content: <HousingLoanQuestion />,
      },
    },
    {
      title: '전세',
      amt: sumAmt(rentFList, 'amt'),
      htxAmt: sumAmt(rentFList, 'htx_amt'),
      done: isQuestionDone(rentFList),
      question: {
        title: '주택관련 소득공제(전세세액공제)',
        content: <HousingRentFQuestion />,
      },
    },
    {
      title: '월세',
      amt: sumAmt(rentMList, 'amt'),
      htxAmt: sumAmt(rentMList, 'htx_amt'),
      done: isQuestionDone(rentMList),
      question: {
        title: '주택관련 소득공제(월세세액공제)',
        content: <HousingRentMQuestion />,
      },
    },
    {
      title: '임대차',
      amt: sumAmt(rentPList, 'amt'),
      htxAmt: sumAmt(rentPList, 'htx_amt'),
      done: isQuestionDone(rentPList),
      question: null,
    },
  ];

  const hasHousingAmount = housingSummaryList.some(item => item.amt !== 0 || item.htxAmt !== 0);
  const housingContentOpen = housingOpenOverride !== null ? housingOpenOverride : hasHousingAmount;
  const toggleHousingContentEvt = () => {
    setHousingOpenOverride(!housingContentOpen);
  };

  const gridSet = _.cloneDeep(taxList) || [];

  // 실손의료비 의료비에 포함
  const medicalInsurance = gridSet.find((item: any) => item.id === 'medical_insurance');
  const gridDataSet: any = [];
  gridSet.forEach((item: any) => {
    if (item.id === 'medical') {
      item.sub = medicalInsurance;
    }
    if (item.id !== 'medical_insurance') gridDataSet.push(item);
  });

  const labelSet = gridOptionSet.label;
  const drawHeader = () => {
    return (
      <div className="_row_content _label">
        <div className="_label_row _ft_lb_t1">
          {labelSet.map((item: any, idx: number) => {
            return (
              <div
                className={['_col', item.align].join(' ')}
                style={{ width: item.width }}
                key={idx + '_'}
              >
                <div className="_tit _ft_lb_t1">{item.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const drawRows = () => {
    const customData = (item: any, col: any, type?: string) => {
      let retStr = item[col.col] || '';
      if (col.custom === 'title') retStr = gridFnc.title(item[col.col]);
      if (col.custom === 'priceContent') retStr = gridFnc.priceContent(item[col.col]);
      if (col.custom === 'priceContentT2') retStr = gridFnc.priceContentT2(item[col.col]);
      if (col.custom === 'detail_btn') {
        if (type === 'sub') return <div className="_btn_div"></div>;
        retStr = gridFnc.detailFn(item, setContentModalState);
      }
      return retStr;
    };

    const mainContent = (rowItem: any, idx: number) => {
      const subYN = rowItem.sub ? '_sub' : '';

      return (
        <div className={['_row_set'].join(' ')}>
          <div className="_main">
            {labelSet.map((col: any, i: number) => {
              return (
                <div className="_col _ft_ct_t1" style={{ width: col.width }} key={idx + '_' + i}>
                  <div className="_text">
                    {customData(rowItem, col)}
                    {rowItem.id === 'housing' && col.col === 'category' ? (
                      <button
                        type="button"
                        className={[
                          '_toggle_add_content_btn',
                          housingContentOpen ? '_open' : '_close',
                        ].join(' ')}
                        onClick={() => toggleHousingContentEvt()}
                      >
                        <i
                          className={
                            housingContentOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'
                          }
                        />
                        <span>{housingContentOpen ? '내용닫기' : '내용보기'}</span>
                      </button>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          {subYN !== '' ? (
            <div className="_sub">
              {labelSet.map((col: any, i: number) => {
                return (
                  <div className="_col _ft_ct_t1" style={{ width: col.width }} key={idx + '_' + i}>
                    <div className="_text">{customData(rowItem.sub, col, 'sub')}</div>
                  </div>
                );
              })}
            </div>
          ) : (
            ''
          )}
          {rowItem.id === 'housing' && housingContentOpen ? (
            <div className="_add_content">
              <div className="_add_content_desc">
                * 모든 설문 종료 후 해당 적용금액을 확인 할 수 있습니다.
              </div>
              {housingSummaryList.map((summaryItem, sIdx) => {
                const surbeyStatus = summaryItem.done?.status || '_wait';
                const surbeyLabel = summaryItem.done?.label || '';

                const question = summaryItem.question;
                const isZeroAmount = summaryItem.amt === 0 && summaryItem.htxAmt === 0;
                return (
                  <div className="_row_item" key={sIdx}>
                    <div className="_title">{summaryItem.title}</div>
                    <div className="_cont">
                      <div className="_item">
                        <div className="_label">금액(국세청)</div>
                        <div className="_value">
                          {addComma(summaryItem.htxAmt)}
                          <em>원</em>
                        </div>
                      </div>
                      <div className="_item">
                        <div className="_label">금액(일반)</div>
                        <div className="_value">
                          {addComma(summaryItem.amt)}
                          <em>원</em>
                        </div>
                      </div>
                      {/* <div className="_item">
                        <div className="_label">적용금액</div>
                        <div className="_value">
                          {addComma(0)}
                          <em>원</em>
                        </div>
                      </div> */}
                    </div>
                    <div className="_btn">
                      {question ? (
                        <SurveyButton
                          clickEvent={() => questionClickEvent(question.title, question.content)}
                          queLabel={surbeyLabel}
                          type="_t2"
                          status={surbeyStatus}
                          disabled={isZeroAmount}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            ''
          )}
        </div>
      );
    };

    return gridDataSet.map((rowItem: any, idx: number) => {
      return (
        <div className="_content" key={idx}>
          {mainContent(rowItem, idx)}
        </div>
      );
    });
  };

  const noContent = () => {
    return (
      <div className="_no_result">
        <div className="_label _ft_lb_t3">No Content</div>
      </div>
    );
  };

  return (
    <div className="_step_c_hometax_data">
      <div className="_content">
        <div className="_account_div">
          <div className="_main_account">
            {/* <div className={'_item _minus'}> */}
            <div className={`_item ${taxType.status}`}>
              <div className="_label">{taxType.text}</div>
              <div className="_cont">
                {/* <span className="_seper">{taxType.seper}</span> */}
                {/* {useCountNum(totRefundPaid)} */}
                {addComma(Math.abs(refundStatus))}
                <em>원</em>
              </div>
            </div>
          </div>
          <div className="_sub_account">
            <div className="_item">
              <div className="_label">결정세액</div>
              <div className="_cont">
                {addComma(determinedPaid)}
                <em>원</em>
              </div>
            </div>
            <div className="_item">
              <div className="_label">기납세액</div>
              <div className="_cont">
                {/* {useCountNum(totPrePaid)} */}
                {addComma(prePaid)}
                <em>원</em>
              </div>
            </div>
          </div>
        </div>
        <div className="_hometax_grid_table">
          <div className="_grid_layout">
            <div className={['_grid_box scroll_style', 'type2'].join(' ')}>
              <div className={['_grid'].join(' ')}>
                {drawHeader()}
                <div className="_row_content">
                  {gridDataSet.length > 0 ? drawRows() : noContent()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTaxData;
